import { Country } from '@afterpaytouch/portal-api/types'
import { CheckoutAddress } from './consumer'

export type UnsavedShippingAddress = Omit<ShippingAddress, 'id'>

export type ModifiedShippingAddress = Omit<UnsavedShippingAddress, 'preferred' | 'phoneNumber'>

export interface ShippingAddress extends CheckoutAddress {
  id: number | string
  countryCode: Country
  phoneNumber: string
  preferred: boolean
}

export interface AddressUpdateDetails {
  phoneNumber: string
  shippingAddress: CheckoutAddress
}

export interface UpdateShippingAddress {
  shippingAddressId?: number | string
  addressUpdateDetails: AddressUpdateDetails
}

export interface ShippingAddressFormData {
  fullContactName: string
  address1: string
  address2: string
  area2: string
  countryCode: Country
  mobile: string
  postcode: string
  state: string
  suburb: string
  isPreferredAddress: boolean
}

export const FULL_CONTACT_NAME = 'fullContactName'
export const ADDRESS_1 = 'address1'
export const ADDRESS_2 = 'address2'
export const ADDRESS = 'address'
export const AREA_2 = 'area2'
export const COUNTRY_CODE = 'countryCode'
export const MOBILE = 'mobile'
export const POSTCODE = 'postcode'
export const STATE = 'state'
export const SUBURB = 'suburb'
export const IS_PREFERRED_ADDRESS = 'isPreferredAddress'

export interface NewAddressTouched {
  [x: string]: boolean
}

export interface NewAddressErrors {
  [x: string]: boolean
}

export enum ShippingAddressStatus {
  Initial,
  Initialising,
  Initialised,
  Error,
}

export const isShippingAddress = (e: any): e is ShippingAddress => {
  return 'id' in e && 'phoneNumber' in e && 'preferred' in e
}
